
// import TopHeader from "../../../../components/general/TopHeader";

// import UserAnalyticsTab from "./UserAnalyticsTabs/UserAnalyticsTabs";


// export default function UserAnalytics() {
//     return (
//         <>
//             <TopHeader />
//             <UserAnalyticsTab />
//         </>
//     )
// }


import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'

import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';

import TopHeader from "../../../../components/general/TopHeader";

import UserAnalyticsTab1 from './UserAnalyticsTabs/UserAnalyticsTab1/UserAnalyticsTab1';
import UserAnalyticsTab2 from './UserAnalyticsTabs/UserAnalyticsTab2/UserAnalyticsTab2';


export default function UserAnalytics() {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));


    const [key, setKey] = useState('Tab1');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    return (
        <Box>
            <CssBaseline />
            <TopHeader />
            <Box mt={spacing(1)}>
                <Stack direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation" onClick={handleClick}>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {/* Business Dashboard */}
                    </NavLink>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {/* {location.pathname} */}
                    </NavLink>
                </Stack>
                <Tabs
                    style={{ justifyContent: "flex-end" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >



                    <Tab eventKey="Tab1" title="Tab1">

                    <UserAnalyticsTab1/>
                    </Tab>

                    <Tab eventKey="Tab2" title="Tab2">

                        <UserAnalyticsTab2 />
                    </Tab>

             

                </Tabs>
            </Box>
        </Box>

    )
}
